import React, { FC, useEffect } from "react";
import useSWR from "swr";

import { Link, Section } from "@in/component-library";

import { getSignedOutLayout } from "../../apis/get-signed-out-layout";

import Page from "../../components/page/page";

const ErrorPage: FC = () => {
  const { data: layout } = useSWR("layout/signed-out-layout", getSignedOutLayout);

  useEffect(() => {
    if (
      layout?.translations?.applicationTitle &&
      layout?.translations?.applicationsHeader &&
      layout?.translations?.companyName
    ) {
      document.title = `${layout.translations.errorMessage} - ${layout?.translations.applicationTitle} - ${layout.translations.companyName}`;
    }
  }, [layout]);

  return (
    <Page inputs={[layout]}>
      <Section>
        <div className="signed-out-page" tabIndex={-1}>
          <h1>{layout?.translations?.errorMessage}</h1>
          <Link href="/">{layout?.translations?.navigationHrefLabel}</Link>
        </div>
      </Section>
    </Page>
  );
};

export default ErrorPage;
